<template>
  <div class="activities">
    <div class="activities__title h1">
      <div>{{'activitiesTitle1' | localize}}&nbsp;</div>
      <div>{{'activitiesTitle2' | localize}}&nbsp;</div>
      <div>{{'activitiesTitle3' | localize}}&nbsp;</div>
      <div>{{'activitiesTitle4' | localize}}&nbsp;</div>
    </div>

    <div class="activities__wrap">
      <div class="activities__web" @click="modalShow(modals.web)"></div>
      <div class="activities__web-text">
        {{'webDescription' | localize}}
        <div class="activities__web-arrow">
          <img src="/img/activities/arrow-web.svg" alt="arrow-web" />
        </div>
      </div>

      <transition name="fade">
        <Modal :dataValue="modals.web" v-if="modals.web.show">
          <p>
            {{'webText' | localize}}
            <br />
            <b>{{'usuallyUse' | localize}}</b>
            <span class="activities__skils">{{'webSkils' | localize}}</span>
          </p>

          <a
            href="#contacts"
            class="btn-primary margin-top"
            v-smooth-scroll
            @click="modalHidden(modals.web)"
          >{{'webButton' | localize}}</a>
        </Modal>
      </transition>

      <div class="activities__ux" @click="modalShow(modals.ux)"></div>
      <div class="activities__ux-text">
        {{'uxDescription' | localize}}
        <div class="activities__ux-arrow">
          <img src="/img/activities/arrow-web.svg" alt="arrow-web" />
        </div>
      </div>

      <transition name="fade">
        <Modal :dataValue="modals.ux" v-if="modals.ux.show">
          <p>{{'uxText' | localize}}</p>
          <a
            href="#contacts"
            class="btn-primary margin-top"
            v-smooth-scroll
            @click="modalHidden(modals.ux)"
          >{{'uxButton' | localize}}</a>
        </Modal>
      </transition>

      <div class="activities__mobile" @click="modalShow(modals.mobile)"></div>
      <div class="activities__mobile-text">
        {{'mobileDescription' | localize}}
        <div class="activities__mobile-arrow">
          <img src="/img/activities/arrow-web.svg" alt="arrow-web" />
        </div>
      </div>

      <transition name="fade">
        <Modal :dataValue="modals.mobile" v-if="modals.mobile.show">
          <p>
            {{'mobileText' | localize}}
            <br />
            <b>{{'usuallyUse' | localize}}</b>
            <span class="activities__skils">{{'mobileSkils' | localize}}</span>
          </p>

          <a
            href="#contacts"
            class="btn-primary margin-top"
            v-smooth-scroll
            @click="modalHidden(modals.mobile)"
          >{{'mobileButton' | localize}}</a>
        </Modal>
      </transition>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/app/Modal";

export default {
  name: "ActivitiesMobile",
  data: () => ({
    modals: {
      web: {
        show: false,
        name: "web",
        title: "WEB DEVELOPMENT",
      },
      ux: {
        show: false,
        name: "ux",
        title: "UI/UX design",
      },
      mobile: {
        show: false,
        name: "mobile",
        title: "MOBILE DEVELOPMENT",
      },
    },
    modalShowed: {},
  }),
  methods: {
    modalShow(modal) {
      this.modalShowed = modal;
      modal.show = true;
      this.$router.push({ query: { modal: modal.name } });
    },
    modalHidden(modal) {
      this.$router.push({ query: "" });
      modal.show = false;
    },
  },
  created() {
    if (this.$route.query.modal) {
      this.modals[this.$route.query.modal].show = true;
    }
    window.onpopstate = () => {
      if (this.$route.query.modal) {
        this.modals[this.$route.query.modal].show = true;
      } else {
        this.modalShowed.show = false;
      }
    };
  },
  components: {
    Modal,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.activities {
  @extend .text-center;
  padding: 45px 0;

  &__wrap {
    height: 766px;
    background: url(/img/mobile/activities/page3.svg) no-repeat;
    background-position-x: center;
    background-size: 517px;
    margin-top: 60px;
    position: relative;
  }

  &__title {
    @extend .text-center;
  }

  &__web,
  &__ux,
  &__mobile {
    @extend .pointer, .absolute, .transition;
    border-radius: 50%;
    transform: scale(0.9);

    &:hover {
      transform: scale(1);
    }
  }

  &__web {
    width: 154px;
    height: 164px;
    background: url(/img/mobile/activities/web.svg) 50% 50% / cover;
    left: calc(50% + 0px);
    top: 120px;

    &-text {
      @extend .absolute, .text-center;
      width: 160px;
      right: calc(50% - 113px);
      top: 82px;
      font-size: 15px;
    }

    &-arrow {
      @extend .absolute;
      bottom: -47px;
      left: 33px;
      transform: scaleX(-1);
    }
  }

  &__ux {
    width: 124px;
    height: 127px;
    background: url(/img/mobile/activities/ux.svg) 50% 50% / cover;
    left: calc(50% - 182px);
    top: -53px;

    &-text {
      @extend .absolute, .text-center;
      width: 162px;
      left: calc(50% - 65px);
      top: -50px;
      font-size: 15px;
    }

    &-arrow {
      @extend .absolute;
      bottom: -37px;
      left: 14px;
      transform: rotate(23deg);
    }
  }

  &__mobile {
    width: 170px;
    height: 170px;
    background: url(/img/mobile/activities/mobile.svg) 50% 50% / cover;
    right: calc(50% + 15px);
    bottom: 323px;

    &-text {
      @extend .absolute, .text-center;
      width: 166px;
      right: calc(50% - 28px);
      font-size: 15px;
      top: 240px;
    }

    &-arrow {
      @extend .absolute;
      bottom: -49px;
      left: 100px;
    }
  }

  &__skils {
    opacity: 0.7;
  }
}

.btn-primary {
  height: 80px;
  line-height: 80px;
  padding: 0 50px;
}
</style>
